/* ---- cart drawer ---- */
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.upsellHandles = this.getUpsellHandles();
    this.quantityGifts = document.querySelector(".quantity-gifts");
    this.checkForClear();
    this.addEventListener("keyup", t => t.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.cartBodyScroll = 0;
  }
  setHeaderCartIconAccessibility() {
    let t = document.querySelector("#cart-icon-bubble");
    if (!t || (t.tagName == "DIV" && (t = t.closest(".header__icon--cart")), !t)) {
      return;
    }
    let x = t.closest(".header__icons");
    t.setAttribute("role", "button");
    t.setAttribute("aria-haspopup", "dialog");
    t.addEventListener("click", x => {
      x.preventDefault();
      this.open(t);
    });
    this.oseid = x.querySelector("form").dataset[this.dataset.type];
    t.addEventListener("keydown", x => {
      if (x.code.toUpperCase() === "SPACE") {
        x.preventDefault();
        this.open(t);
      }
    });
  }
  open($) {
    if ($) {
      this.setActiveElement($);
    }
    let x = this.querySelector("[id^=\"Details-\"] summary");
    if (x && !x.hasAttribute("role")) {
      this.setSummaryAccessibility(x);
    }
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener("transitionend", () => {
      let x = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
      let e = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
      trapFocus(x, e);
    }, {
      once: true
    });
    document.body.classList.add("overflow-hidden");
    let e = this.querySelector("countdown-timer");
    if (e) {
      e.playTimer();
    }
  }
  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    let t = this.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
    let x = [];
    t.forEach(t => {
      if (t.dataset.handle) {
        x.push(t.dataset.handle);
      }
    });
    return x;
  }
  oneNonUpellRemaining() {
    let t = this.querySelectorAll(".cart-item");
    let x = 0;
    t.forEach(t => {
      this.upsellHandles.forEach($ => {
        if (t.classList.contains("cart-item--product-" + $)) {
          x++;
        }
      });
    });
    return t.length - x <= 1;
  }
  checkForClear() {
    let t = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach(x => {
      if (t) {
        x.clearCart = true;
      } else {
        x.clearCart = false;
      }
    });
  }
  setSummaryAccessibility($) {
    $.setAttribute("role", "button");
    $.setAttribute("aria-expanded", "false");
    if ($.nextElementSibling.getAttribute("id")) {
      $.setAttribute("aria-controls", $.nextElementSibling.id);
    }
    $.addEventListener("click", $ => {
      $.currentTarget.setAttribute("aria-expanded", !$.currentTarget.closest("details").hasAttribute("open"));
    });
    $.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents($, t = false) {
    if (this.querySelector(".drawer__inner").classList.contains("is-empty")) {
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    }
    this.productId = $.id;
    this.getSectionsToRender().forEach(t => {
      let i = t.selector ? document.querySelector(t.selector) : document.getElementById(t.id);
      if (i) {
        i.innerHTML = this.getSectionInnerHTML($.sections[t.id], t.selector);
        let s = i.querySelector(".cart-drawer__body");
        if (s) {
          s.scrollTop = this.cartBodyScroll;
        }
      }
    });
    this.checkForClear();
    let e = this.querySelector("countdown-timer");
    if (e && e.playTimer) {
      e.playTimer();
    }
    let i = [];
    let s = [];
    this.querySelectorAll("cart-drawer-gift").forEach($ => {
      if ($.getUpdateRequired()) {
        if (this.querySelector(".cart-item--product-" + $.dataset.handle)) {
          if ($.dataset.selected === "false") {
            s.push($);
          }
        } else if ($.dataset.selected === "true") {
          i.push($);
        }
      }
    });
    if (s.length > 0) {
      s[0].removeFromCart();
    } else if (i.length > 0) {
      i[0].addToCart();
    } else {
      if (this.quantityGifts) {
        this.quantityGifts.initUnlock();
      }
      let a = document.querySelectorAll("quantity-break-upsells");
      a.forEach($ => {
        $.initUnlock();
      });
    }
    validateCartGifts();
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      if (!t) {
        this.open();
      }
    });
  }
  getSectionInnerHTML($, t = ".shopify-section") {
    let e = new DOMParser().parseFromString($, "text/html").querySelector(t);
    if (t === "#CartDrawer") {
      fixParsedHtml(this, e);
    }
    return e.innerHTML;
  }
  getSectionsToRender() {
    return [{
      id: "cart-drawer",
      selector: "#CartDrawer"
    }, {
      id: "cart-icon-bubble"
    }];
  }
  getSectionDOM($, t = ".shopify-section") {
    return new DOMParser().parseFromString($, "text/html").querySelector(t);
  }
  setActiveElement($) {
    this.activeElement = $;
  }
}
customElements.define("cart-drawer", CartDrawer);

/* ---- cart drawer items ---- */
class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.secondCartItems = document.querySelector("cart-items");
  }
  updateCart() {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname
      })
    }).then(t => t.json()).then(t => {
      document.querySelector("cart-drawer").renderContents(t, true);
    }).catch(t => {
      console.error(t);
    });
  }
  getSectionInnerHTML($, t) {
    let e = new DOMParser().parseFromString($, "text/html").querySelector(t);
    if (t === ".drawer__inner") {
      fixParsedHtml(this.cartDrawer, e);
    }
    return e.innerHTML;
  }
  getSectionsToRender() {
    return [{
      id: "CartDrawer",
      section: "cart-drawer",
      selector: ".drawer__inner"
    }, {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section"
    }];
  }
}

/* ---- define ---- */
customElements.define("cart-drawer-items", CartDrawerItems);
